'use client';
import React, { useState, useRef, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import html2pdf from 'html2pdf.js';
import FormSection from '../components/formsection';
import Navbar from '../components/navbar';
import { Dialog, Classes, Button } from '@blueprintjs/core'; // Import for popup
import { useSelector } from 'react-redux'; // Import useSelector for package comparison
import { FaCrown,FaExclamationTriangle  } from 'react-icons/fa'; // Import the crown icon from react-icons
import { useDispatch } from 'react-redux';
import { loginModal } from '../../../Redux/authAction';
import API from '../../../config/api'; // Import API configuration

export default function SpecificResumeBuilder() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate(); // Use navigate for redirection
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  // Redux selectors for package comparison
  const userID = useSelector((state) => state.authReducer.uid);
  const temp_id = useSelector((state) => state.authReducer.temp_id);
  const packageid = useSelector((state) => state.authReducer.packageid);
  // const packageid = 6;
  const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid);
  const [showExpiredPackagePopUp, setShowExpiredPackagePopUp] = useState(false); // State for showing the premium popup
  const [showPremiumPopup, setShowPremiumPopup] = useState(false); // State for showing the premium popup

  const [jsontemplate, setjsontemplate] = useState('');

  const fetchTemplate = async () => {
    try {
      const req = await fetch(`${API.API_URL}/aapi/templetes/${id}`);
      if (!req.ok) {
        throw new Error(`HTTP error! status: ${req.status}`);
      }
      const json = await req.json();
      console.log(json);
      setjsontemplate(json);
    } catch (error) {
      console.error('Failed to fetch template:', error);
    }
  };

  useEffect(() => {
    fetchTemplate();
  }, [id]);

  const [data, setData] = useState({
    name: '',
    jobTitle: '',
    phone: '',
    email: '',
    address: '',
    summary: '',
    education: [{ degree: '', institution: '', year: '' }],
    expertise: [{ skill: '', number: '' }],
    languages: [''],
    experience: [{ position: '', company: '', duration: '', details: '' }],
    awards: [{ title: '', year: '', details: '' }],
    references: [{ name: '', position: '', phone: '', email: '' }],
    socialMedia: [{ platform: '', handle: '' }],
    imageUrl: null,
  });

  const [sections, setSections] = useState({
    personalDetails: true,
    summary: true,
    educationalDetails: true,
    expertiseDetails: true,
    languageDetails: true,
    experienceDetails: true,
    awards: true,
    referenceDetails: true,
    socialMedia: true,
  });

  const printRef = useRef();

  const toggleSection = (section) => {
    setSections((prevSections) => ({
      ...prevSections,
      [section]: !prevSections[section],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDynamicChange = (e, index, field, key) => {
    const updatedArray = [...data[field]];
    updatedArray[index] = {
      ...updatedArray[index],
      [key]: e.target.value,
    };
    setData((prevData) => ({
      ...prevData,
      [field]: updatedArray,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setData((prevData) => ({
        ...prevData,
        imageUrl: reader.result,
      }));
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const addDynamicField = (field) => {
    setData((prevData) => ({
      ...prevData,
      [field]: [...(prevData[field] || []), { skill: '', number: '' }],
    }));
  };

  const removeDynamicField = (index, field) => {
    const updatedArray = data[field].filter((_, i) => i !== index);
    setData((prevData) => ({
      ...prevData,
      [field]: updatedArray,
    }));
  };


  const [showOneTimePlanPopup, setShowOneTimePlanPopup] = React.useState(false); // State for one-time plan popup


  const handleDownload = async () => {
    console.log(
      "user Id:", userID,
      "user package id", packageid,
      "template Package id:", temp_pkgid,
      "template id : ", temp_id
    );

    // Check if the user is allowed to download based on package levels
    if (temp_pkgid == 4) {
      try {
        // Make a POST request to check the subscription, passing userID via FormData
        const formData = new FormData();
        formData.append("userid", userID);
        formData.append("tempid", temp_id);

        console.log("FormData:", formData);
        const subscriptionResponse = await fetch(API.getUrl(API.ENDPOINTS.GET_USER_TEMPLATE_SUBSCRIPTION), {
          method: 'POST',
          body: formData,
        });

        if (!subscriptionResponse.ok) {
          throw new Error("Failed to fetch subscription details");
        }

        const result = await subscriptionResponse.json();

        if (result.status === false) {
          setShowOneTimePlanPopup(true); // Show one-time plan popup if user hasn't subscribed
          return;
        }

      } catch (error) {
        console.error("Error fetching subscription or template details:", error);
        return; // Stop execution if any API call fails
      }
    } else {
      if (
        (packageid == 1 && temp_pkgid > 1) ||
        (packageid == 2 && temp_pkgid > 2) ||
        (packageid == 3 && temp_pkgid > 3)
      ) {
        setShowPremiumPopup(true);
        return; // Stop further execution
      }
      else{
        if(packageid == 6 && temp_pkgid > 1 || packageid == 7 && temp_pkgid > 1){
          setShowExpiredPackagePopUp(true);
          return;
        }
      }
    }

    const element = printRef.current;
    const options = {
      filename: `${data.name}_CV.pdf`,
      image: { type: 'png', quality: 1 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'in', format: 'A4', orientation: 'portrait' },
    };
    html2pdf().from(element).set(options).save();
  };

  const handlePrint = async () => {
    console.log(
      "user Id:", userID,
      "user package id", packageid,
      "template Package id:", temp_pkgid,
      "template id : ", temp_id
    );

    // Check if the user is allowed to download based on package levels
    if (temp_pkgid == 4) {
      try {
        // Make a POST request to check the subscription, passing userID via FormData
        const formData = new FormData();
        formData.append("userid", userID);
        formData.append("tempid", temp_id);

        console.log("FormData:", formData);
        const subscriptionResponse = await fetch(API.getUrl(API.ENDPOINTS.GET_USER_TEMPLATE_SUBSCRIPTION), {
          method: 'POST',
          body: formData,
        });

        if (!subscriptionResponse.ok) {
          throw new Error("Failed to fetch subscription details");
        }

        const result = await subscriptionResponse.json();

        if (result.status === false) {
          setShowOneTimePlanPopup(true); // Show one-time plan popup if user hasn't subscribed
          return;
        }

      } catch (error) {
        console.error("Error fetching subscription or template details:", error);
        return; // Stop execution if any API call fails
      }
    } else {
      if (
        (packageid == 1 && temp_pkgid > 1) ||
        (packageid == 2 && temp_pkgid > 2) ||
        (packageid == 3 && temp_pkgid > 3)
      ) {
        setShowPremiumPopup(true);
        return; // Stop further execution
      }
      else{
        if(packageid == 6 && temp_pkgid > 1 || packageid == 7 && temp_pkgid > 1){
          setShowExpiredPackagePopUp(true);
          return;
        }
      }
    }

    // Proceed with printing if package is allowed
    const printContent = useReactToPrint({
      content: () => printRef.current,
    });
    printContent();
  };
  

  const saveToLocalStorage = () => {
    localStorage.setItem('formData', JSON.stringify(data));
  };

  const loadScripts2 = () => {
    if (jsontemplate && jsontemplate.scripts) {
      const scripts = jsontemplate.scripts;
      const scriptTags = Object.values(scripts);

      scriptTags.forEach((script) => {
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.innerHTML = script;

        // Ensure the script is appended after the template is fully rendered
        if (printRef.current) {
          document.body.appendChild(scriptElement);
        }
      });
    }
  };

  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu);

    // Disable Save (Ctrl+S) and Print (Ctrl+P)
    const handleKeydown = (e) => {
      if ((e.ctrlKey && e.key === 'p') || (e.ctrlKey && e.key === 's')) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    document.addEventListener('keydown', handleKeydown);

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  useEffect(() => {
    if (jsontemplate && jsontemplate.template) {
      setTimeout(() => {
        loadScripts2(); // Load scripts after template rendering
        if (typeof window.updateTemplate === 'function') {
          window.updateTemplate(data); // Update the template with form data
        }
      }, 0);
    }
  }, [jsontemplate, data]);


  const handlePayNow = async () => {
    const handleOpen = () => dispatch(loginModal(true));
    if (!isAuthenticated) {
      handleOpen();
      return;
    }
  
    const formData = new FormData();
    formData.append('tempid', temp_id);
  
    try {
      // Make the POST request
      const response = await fetch(API.getUrl(API.ENDPOINTS.GET_TEMPLATE_PRICE), {
        method: 'POST',
        body: formData,
      });
  
      // Ensure the response is OK
      if (!response.ok) {
        throw new Error('Failed to fetch template price');
      }
  
      // Parse the JSON response
      const data = await response.json();
  
      // Check if the response status is success and the amount exists
      if (data.status === "success" && data.temp_amount !== undefined) {
        const amount = data.temp_amount;
        console.log("Template Amount is: ", amount);
  
        // Construct the payment URL
        const url = `${API.API_URL}${API.ENDPOINTS.ONE_TIME_PAY}?amount=${encodeURIComponent(amount)}&customerEmail=${encodeURIComponent(email)}&userid=${encodeURIComponent(userID)}&tempid=${encodeURIComponent(packageid)}`;
  
        // Open the payment URL in a new tab
        window.open(url, '_blank');
      } else {
        console.error('Failed to retrieve template amount or invalid response:', data);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  return (
    <>
      <Navbar handleDownload={handleDownload} handlePrint={handlePrint} saveToLocalStorage={saveToLocalStorage} />
      <div className="min-h-screen w-full bg-gray-100 p-8">
        <div className="mx-auto w-full flex md:flex-row flex-col gap-4 space-x-4">
          {/* Form Section */}
          <FormSection
            data={data}
            setData={setData}
            sections={sections}
            toggleSection={toggleSection}
            handleChange={handleChange}
            handleDynamicChange={handleDynamicChange}
            handleImageChange={handleImageChange}
            addDynamicField={addDynamicField}
            removeDynamicField={removeDynamicField}
            handleDownload={handleDownload}
            handlePrint={handlePrint}
          />
          {/* CV Preview Section */}
          <span ref={printRef} className="w-full">
            {jsontemplate && jsontemplate.template ? (
              <div contentEditable="false" dangerouslySetInnerHTML={{ __html: jsontemplate.template }}></div>
            ) : (
              <p>Loading template...</p>
            )}
          </span>
        </div>
      </div>

      {/* Premium template popup */}
     
<Dialog
  icon="warning-sign"
  onClose={() => setShowPremiumPopup(false)}
  title="Premium Template"
  isOpen={showPremiumPopup}
  style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }} // Adds custom styling
>
  <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
    <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
      This is a premium template. Please upgrade your package to download or print it.
    </p>
    <FaCrown size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
  </div>
  <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
    <Button
      intent="primary"
      style={{
        backgroundColor: '#9333EA',
        color: 'white',
        fontWeight: 'bold',
        padding: '10px 20px',
        borderRadius: '5px',
      }}
      onClick={() => navigate('/price')}
    >
      Go to Pricing Page
    </Button>
    <Button
      style={{
        backgroundColor: '#F55656',
        color: 'white',
        fontWeight: 'bold',
        padding: '10px 20px',
        borderRadius: '5px',
      }}
      onClick={() => setShowPremiumPopup(false)}
    >
      Close
    </Button>
  </div>
</Dialog>
<Dialog
        icon="warning-sign"
        onClose={() => setShowOneTimePlanPopup(false)}
        title="One-Time Plan Template"
        isOpen={showOneTimePlanPopup}
        style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      >
        <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
          <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
            This template is only available in the one-time plan. Please go and purchase it!
          </p>
          <FaCrown size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button
            intent="primary"
            style={{
              backgroundColor: '#9333EA',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={handlePayNow}
          >
            Buy Now
          </Button>
          <Button
            style={{
              backgroundColor: '#F55656',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => setShowOneTimePlanPopup(false)}
          >
            Close
          </Button>
        </div>
      </Dialog>
      <Dialog
        icon="warning-sign"
        onClose={() => setShowExpiredPackagePopUp(false)}
        title="Package has been Expired"
        isOpen={showExpiredPackagePopUp}
        style={{ width: '400px', borderRadius: '10px', padding: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
      >
        <div className={Classes.DIALOG_BODY} style={{ textAlign: 'center', paddingBottom: '20px' }}>
          <p style={{ fontSize: '16px', color: '#5c7080', marginBottom: '20px' }}>
           Your Package has been Expired. Please go and Renew it!
          </p>
          <FaExclamationTriangle  size={80} color="#FFD700" style={{ margin: '0 auto', display: 'block', marginBottom: '20px' }} />
        </div>
        <div className={Classes.DIALOG_FOOTER} style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <Button
            intent="primary"
            style={{
              backgroundColor: '#9333EA',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => navigate('/price')}
          >
            Renew
          </Button>
          <Button
            style={{
              backgroundColor: '#F55656',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              borderRadius: '5px',
            }}
            onClick={() => setShowExpiredPackagePopUp(false)}
          >
            Close
          </Button>
        </div>
      </Dialog>
 </> ); }